.catsel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: none;
}

/* Same treatment as the section-head kickers, one step down. */
.catsel__label {
  font-size: 11px; /* COPY_XS */
  /* HACK: the design's label weight is heavier than any COPY token, which tops out at 600. */
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-text-tertiary); /* TEXT_TERTIARY */
  /* HACK: lines the label up with the pill's text rather than its edge — no DS spacing for this. */
  padding-left: 24px;
}

.catsel__box {
  position: relative;
  display: flex;
  /* HACK: spring easing from the design; the DS motion tokens have no overshoot curve. */
  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.catsel__box:hover {
  transform: var(--plume-hover-shift, translateY(-3px));
}

.catsel__select {
  appearance: none;
  -webkit-appearance: none;
  font-family: inherit;
  font-size: 16px; /* COPY_M */
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: var(--plume-round-button-radius, 40px);
  /* HACK: pill sized off the design; no DS control height matches (the DS select is 50px). */
  height: 56px;
  /* Right padding clears the chevron, which sits 24px in from the edge. */
  padding: 0 56px 0 24px;
  /* HACK: holds the pill wide enough for the longest label ("Toutes les catégories"). */
  min-width: 304px;
  width: 100%;
  cursor: pointer;
  box-shadow: var(--plume-shadow-bulle, 1px 2px 6px 0 rgba(89, 84, 78, 0.12));
  transition: box-shadow 0.22s ease;
}

.catsel__box:hover .catsel__select {
  box-shadow: var(--plume-shadow-card, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
}

.catsel__select:focus-visible {
  outline: 3px solid var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
  outline-offset: 3px;
}

.catsel__chev {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 9px;
  pointer-events: none;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

@media (max-width: 560px) {
  .catsel,
  .catsel__select {
    width: 100%;
    min-width: 0;
  }
}
